import React from "react";
import Brick from './BrickCore';
import { Field } from 'redux-form';
import { Col, FormGroup, Label } from 'reactstrap';

/** Class representing a workflow brick to
 * initialize to update a cart user data
 *
 * [server_side]
 */
class CartSetUserData extends Brick {
    /**
     * Get this brick options form
     *
     * @param {Object} props: an object with the following keys
     *                          - t
     *                          - workflow
     *                          - forms
     *                          - emails
     *                          - articles
     *                          - salepoints
     */
    getOptionsForm(props) {
        const { t } = props;
        return (
            <FormGroup row >
                <Label for="comment" className="text-v-center" sm={12}>
                    {t("workflows.bricks.cart.set.user.data.options.comment")}
                </Label>
                <Col sm={12}>
                    <Field component="textarea" name={`bricks[${this.position}].options.comment`} className="form-control" />
                </Col>
            </FormGroup>
        );
    }
}

export default CartSetUserData;
